// extracted by mini-css-extract-plugin
export default {"categories-list":"d2RF1"};